module.exports = __webpack_public_path__ + "img/1212e_2.a9bbc206.jpg";